/**
 * @description  异步修改state，vue中使用 this.$store.dispatch('name').then(() => {})调用
 */
import name from './mutationsName';

export default {
  setUserInfoAsync ({commit}, userInfo) {
    return new Promise(resolve => {
      commit(name.SET_USER_INFO, userInfo);
      resolve();
    })
  }
}